"use client";

import React from "react";
import { Cpu, PhoneCall, FileCheck, Wrench, Rocket, ArrowRight, Activity, Clock, TrendingUp } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  id: "PILIER.01",
  label: "EXPERTISE RÉGLEMENTAIRE",
  heading: "Sûreté Juridique",
  description: "EFFET CONSEIL maîtrise les cadres réglementaires : réglementation de la formation professionnelle, France Compétences, Référentiel National Qualité. En tant qu’évaluatrice technique pour Cofrac, je suis également au cœur des évolutions normatives et des pratiques d’excellence.",
  icon: FileCheck,
  align: "left",
  colSpan: "md:col-span-5 md:col-start-2"
}, {
  id: "PILIER.02",
  label: "VULGARISATION ET ACESSIBILITÉ",
  heading: "Accessibilité Totale",
  description: "Les textes réglementaires sont souvent complexes et techniques. Le rôle d’EFFET CONSEIL est de les décrypter, de les traduire en langage clair et de les rendre accessibles à tous vos collaborateurs, quelle que soit leur niveau initial. L’objectif : que chacun comprenne les enjeux et s’approprie les bonnes pratiques.",
  icon: PhoneCall,
  align: "right",
  colSpan: "md:col-span-5 md:col-start-7"
}, {
  id: "PILIER.03",
  label: "CO-CONSTRUCTION SYSTÉMATIQUE",
  heading: "Synergie de Terrain",
  description: "Aucun accompagnement ne peut réussir sans l’implication de vos équipes. EFFET CONSEIL privilégie la co-construction à chaque étape : votre expertise métier, vos pratiques terrain et votre connaissance de vos publics sont indispensables. Mon rôle est de structurer, formaliser et sécuriser ce qui existe déjà chez vous.",
  icon: Activity,
  align: "left",
  colSpan: "md:col-span-5 md:col-start-2"
}, {
  id: "PILIER.04",
  label: "APPROCHE ÉTHIQUE & RESPONSABLE",
  heading: "Conformité Engagée",
  description: "EFFET CONSEIL intègre une dimension RSE dans tous ses accompagnements. Référente RSE certifiée, j’applique des principes éthiques dans mes pratiques : respect des personnes, transparence, équité, amélioration continue et responsabilité environnementale. Ces valeurs irriguent la manière dont nous travaillons ensemble et la façon dont vos dispositifs sont conçus.",
  icon: Wrench,
  align: "right",
  colSpan: "md:col-span-5 md:col-start-7"
}, {
  id: "PILIER.05",
  label: "ORIENTATION RÉSULTATS",
  heading: "Levier de Performance",
  description: "Les accompagnements sont conçus pour aboutir : durée d’enregistrement RNCP/RS la plus longue possible, absence de non-conformité à l’audit Qualiopi®. Ces résultats reposent sur une rigueur méthodologique et un engagement partagé entre EFFET CONSEIL et vos équipes.",
  icon: Rocket,
  align: "center",
  colSpan: "md:col-span-8 md:col-start-3"
}];
const protocolFeatures = [{
  title: "Veille Stratégique",
  description: "Anticipation des changements normatifs pour garder une longueur d'avance sur la concurrence.",
  icon: Clock
}, {
  title: "Maîtrise des Risques",
  description: "Sécurisation juridique complète de vos parcours de formation et de vos certifications RNCP.",
  icon: Cpu
}, {
  title: "Performance Durable",
  description: "Transformation des contraintes réglementaires en avantages compétitifs sur le long terme.",
  icon: TrendingUp
}];
function StepCard({
  step,
  index
}: {
  step: typeof steps[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <div data-section-id="159520" data-index={index} ref={ref} className={`
        ${step.colSpan} 
        transition-all duration-1000 ease-out
        ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}
        ${index > 0 ? 'mt-8 md:mt-24' : ''}
      `}>
      <Card className="bg-white/80 dark:bg-card/50 backdrop-blur-md border-border shadow-sm rounded-sm overflow-hidden relative group hover:border-secondary/30 transition-colors duration-500">
        {}
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
        
        <CardHeader className="pb-4 relative z-10">
          <div className="flex items-center justify-between mb-4">
            <Badge variant="outline" className="text-xs inline-flex items-center justify-center border px-2 py-0.5 w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-accent [a&]:hover:text-accent-foreground font-sans text-secondary border-secondary/20 bg-secondary/5 tracking-widest rounded-sm !text-3xl !font-semibold dark:aria-invalid:ring-destructive/40">
              PILLIER.{step.id}
            </Badge>
            <step.icon className="w-6 h-6 text-muted-foreground group-hover:text-primary transition-colors duration-300 stroke-[1.5]" />
          </div>
          <div className="space-y-1">
            <p className="font-sans tracking-widest uppercase !text-[hsl(210,10%,23%)] !text-2xl">
              {step.label}
            </p>
            
          </div>
        </CardHeader>
        <CardContent className="relative z-10">
          <CardDescription className="font-sans leading-relaxed text-foreground/80 !text-base">
            {step.description}
          </CardDescription>
        </CardContent>
      </Card>
    </div>;
}
export default function HowItWorks() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: protocolRef,
    isVisible: isProtocolVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}